import {
  /* `saveAs` is a function from the `file-saver` library. It is used to save a file with a
given blob and filename. In the provided code, it is used to save the Excel file with the
generated blob and the specified filename. */
  Col,
  Container,
  Row,
} from "react-bootstrap";
import { logoBase64 } from "../../../procedure/info-technology-process/repair-tools/base64";
import { ConvertHTMLService } from "../../../../services/department-viags/convert-pdf.service";
import { saveAs } from "file-saver";
import { getDDMMYYYFormat } from "../../../../helper/dateTimeHelper";
import { CreateNotification } from "../../../../components/notifier";
import { Button, Checkbox, message, Popover } from "antd";
import { useState } from "react";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { FontFa } from "../../../../components";
import { useMineInfo } from "../../../../contexts/mine-info-context";
import PERMISSIONS from "../../../../constants/permissions";
import MESSAGES from "../../../../constants/messages";

interface EditorHeaderProps {
  content: any; // Kiểu dữ liệu cần chỉnh sửa tại đây
  documentInfo: any;
  isAdmin: boolean;
  isChangedViewMode: boolean;
}

// interface TreeNode {
//   data: any; // Replace 'any' with a specific type if you know the structure
//   children: TreeNode[];
// }

export const EditorHeader = (props: EditorHeaderProps) => {
  const { content, documentInfo, isChangedViewMode, isAdmin } = props;
  const [open, setOpen] = useState(false);
  const [isValid, setIsValid] = useState(false);

  const { checkPermission } = useMineInfo();

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const currentDate = new Date();
  const date = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;

  const buildHtmlTree = (elements: Element[], customId: string | undefined, level: number = 0): string => {
    let html = "";

    const matchingElements: any = elements.filter((element: any) => element.CustomParentId === customId);

    if (matchingElements.length === 0) {
      return html;
    }

    for (const matchingElement of matchingElements) {
      const padding = level * 10; // Calculate padding based on the level
      const paddingStyle = `padding-left: ${padding}px;`;
      html += `<div style="text-align: justify; ${paddingStyle}">${matchingElement.Content}${buildHtmlTree(
        elements,
        matchingElement.CustomId,
        level + 1,
      )}</div>`;
    }

    return html;
  };

  const printDocument = () => {
    if (!checkPermission(PERMISSIONS.DOWNLOAD_OR_PRINT_DRAFT)) return message.error(MESSAGES.NOT_PERMISSION);

    const htmlHeader = `<table style="border-collapse: collapse;" cellspacing="0" height="10%" width="100%">
    <tr height="20px">
        <td
            style="
                border-top-style: solid;
                border-top-width: 1pt;
                border-left-style: solid;
                border-left-width: 1pt;
                border-bottom-style: solid;
                border-bottom-width: 1pt;
                border-right-style: solid;
                border-right-width: 1pt;
            "
            rowspan="2"
        >
            <p style="padding-left: 14pt; text-indent: 0pt; text-align: left;">
                <span style="text-align: center; display: flex; align-items: center; justify-content: center">
                  <img
                    width="150px"
                    height="50px"
                    src=${logoBase64}
                   />
                </span>
            </p>
        </td>
        <td
            style="
                width: 197pt;
                border-top-style: solid;
                border-top-width: 1pt;
                border-left-style: solid;
                border-left-width: 1pt;
                border-bottom-style: solid;
                border-bottom-width: 1pt;
                border-right-style: solid;
                border-right-width: 1pt;
                padding-bottom: 25px;
            "
            rowspan="2"
        >
            <p class="s1" style="padding-left: 5pt; text-indent: 0pt; text-align: left; margin-bottom: 0; font-style: italic; font-weight: 500">Biểu mẫu</p>
            <p style="text-indent: 0pt; text-align: left;margin-bottom: 0; display:none"><br /></p>
            <p class="s1" style="text-align: center; padding: 0px 10px;">${documentInfo?.Title || ""}</p>
        </td>
        <td
            style="
                width: 113pt;
                border-top-style: solid;
                border-top-width: 1pt;
                border-left-style: solid;
                border-left-width: 1pt;
                border-bottom-style: solid;
                border-bottom-width: 1pt;
                border-right-style: solid;
                border-right-width: 1pt;
            "
        >
            <p class="s2" style="padding-left: 5pt; text-indent: 0pt; text-align: left">Mã số: ${
              documentInfo?.docCode || ""
            }</p>
        </td>
    </tr>
    <tr style="height: 48pt;">
        <td
            style="
                width: 113pt;
                border-top-style: solid;
                border-top-width: 1pt;
                border-left-style: solid;
                border-left-width: 1pt;
                border-bottom-style: solid;
                border-bottom-width: 1pt;
                border-right-style: solid;
                border-right-width: 1pt;
            "
        >
            <p class="s2" style="padding-left: 5pt; text-indent: 0pt; text-align: left;margin-bottom: 0">Ban hành: ${
              +documentInfo.docPublishViewVersion || ""
            }</p>
            <p class="s2" style="padding-left: 5pt; text-indent: 0pt; text-align: left;margin-bottom: 0">Lần sửa đổi: ${
              +documentInfo.docEditionVersion || ""
            }</p>
            <p class="s2" style="padding-left: 5pt; text-indent: 0pt; text-align: left;margin-bottom: 0">Hiệu lực: ${getDDMMYYYFormat(
              documentInfo.effectiveFrom,
            )} </p>
        </td>
    </tr>
  </table>
  `;

    // addRootIfMissing(content)

    const htmlBody = buildHtmlTree(content, undefined);

    const fields = {
      htmlHeader: htmlHeader,
      htmlBody: htmlBody,
      htmlFooter: isValid ? `<p style={{font-weight: "bold"}}>Tài liệu không kiểm soát khi download/in ra</p>` : "",
    };
    CreateNotification({
      title: "In thành công",
      body: "Đang tải xuống thông tin tài liệu",
      icon: "/icons/success.png",
    });

    ConvertHTMLService.convertHTML(fields)
      .then((response) => {
        // Check if the response status code is 200
        if (response && response.data && response.status === 200) {
          const contentType = response.headers["content-type"];
          // Create a Blob from the response data
          const blob = new Blob([response.data], { type: contentType });
          saveAs(blob, `${documentInfo?.Title}.docx`);
        } else {
          console.log("API response status is not 200");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const onChange = (e: CheckboxChangeEvent) => {
    const checked = e.target.checked;
    setIsValid(checked);
  };

  const renderPopover = (
    <div>
      <Checkbox onChange={onChange}>Tài liệu không kiểm soát khi download/in ra</Checkbox>
      <Button size="small" type="primary" style={{ float: "right" }} onClick={printDocument}>
        In
      </Button>
    </div>
  );

  return (
    content && (
      <Container style={{ padding: "5px" }}>
        <Row>
          <Col sm={12} md={12} className="document__view-header">
            <div className="header__content-title header__content">{documentInfo?.Title}</div>
            <div className="header__content-solid header__content">|</div>
            <div className="header__content-date header__content">{date}</div>
            <div className="header__content-solid header__content">|</div>
            {isChangedViewMode && documentInfo?.docStatusId === 8 && isAdmin && (
              <Popover
                content={renderPopover}
                title="In tài liệu"
                trigger="click"
                open={open}
                onOpenChange={handleOpenChange}
              >
                <Button
                  title="In tài liệu"
                  type="text"
                  className="p-2 text"
                  size="large"
                  // onClick={() => {
                  //   openUrl(document?.docUrl + "#toolbar=0");
                  // }}
                  // onClick={printDocument}
                >
                  <FontFa name="faPrint" className="text-primary" size="lg" />
                </Button>
              </Popover>
            )}
          </Col>
        </Row>
      </Container>
    )
  );
};
